// 工单详情
const workorderDetailConfig = [
  {
    label: '工单ID：',
    prop: 'workOrderId'
  },
  {
    label: '处理人：',
    prop: 'operatorName'
  },
  {
    label: '工单类型：',
    prop: 'businessTypeName',
    customRender: item => {
      const { businessType, businessTypeName, followBusinessType } = item
      if (businessType === 33) {
        const type = ['', '医生', '患者'][followBusinessType]
        return `${businessTypeName}-${type}`
      } else {
        return businessTypeName
      }
    }
  },
  {
    label: '工单状态：',
    prop: 'statusName'
  },
  {
    label: '创建时间：',
    prop: 'createTime'
  },
  {
    label: '处理时间：',
    prop: 'dealTime'
  },
  {
    label: '完成时间：',
    prop: 'completeTime'
  },
  {
    label: '过期时间：',
    prop: 'timeoutTime'
  },
  {
    label: '失效时间：',
    prop: 'failureTime'
  }
]
export { workorderDetailConfig }
